import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { authInstance } from "apis";
import CompanyMe from "types/CompanyMe";
import authAtom from "stores/auth";

const useCompanyMe = () => {
  const auth = useRecoilValue(authAtom);

  const fetcher = async () => {
    const { data } = await authInstance.get("company/me");
    return data;
  };
  const { data: companyMe } = useQuery<CompanyMe>(["company/me"], fetcher, {
    enabled: auth.type === "company",
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
  });

  return companyMe;
};

export default useCompanyMe;
